module.exports = __webpack_public_path__ + "files/f85e1e2326543add3468e16070e481a9.png";